import { NgModule } from '@angular/core';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { MultiSelectDropdownComponent } from './multi-select-dropdown.component';

@NgModule({
    imports: [
        AngularMultiSelectModule,
        FormsModule
    ],
    declarations: [
        MultiSelectDropdownComponent
    ],
    exports: [
        MultiSelectDropdownComponent
    ],
    bootstrap: [MultiSelectDropdownComponent]
})
export class MultiSelectDropdownModule { }
